<!--<ng-container *ngIf="useWC; then webComponents; else legacyComponents"></ng-container>-->
<!--<ng-template #webComponents>-->
<!--  <lm-radiobutton-wc-->
<!--    [layoutObject]="layoutObject"-->
<!--    [specFields]="specFields"-->
<!--    [model]="model"-->
<!--    [placeHolder]="placeHolder"-->
<!--    [layoutInfo]="layoutInfo"-->
<!--    [lmColumnLayoutInfo]="lmColumnLayoutInfo"-->
<!--    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"-->
<!--    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"-->
<!--    (fieldEvent)="onFieldEvent($event)"-->
<!--  ></lm-radiobutton-wc>-->
<!--</ng-template>-->
<!--<ng-template #legacyComponents>-->
<lm-radiobutton-soho
  class="field"
  [layoutObject]="layoutObject"
  [specFields]="specFields"
  [model]="model"
  [placeHolder]="placeHolder"
  [layoutInfo]="layoutInfo"
  [lmColumnLayoutInfo]="lmColumnLayoutInfo"
  [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
  [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
  (fieldEvent)="onFieldEvent($event)"
></lm-radiobutton-soho>